import React from 'react';

import urls from '@constants/urls';
import {GetCountryByIp} from '@graphql/country/query';

import apolloClient from '../../../../apolloClient';

export const prepareIpDataRow = (ipData) => {
    return ipData.ipAddress && ipData.country ? `${ipData.ipAddress} (${ipData.country})` : 'Not detected';
};

export const ipInfoDataForTooltip = (ipV4, ipV6) => {
    const ipV4Data = prepareIpDataRow(ipV4),
        ipV6Data = prepareIpDataRow(ipV6);

    return (
        <div>
            <ul>
                <li><b>IPv4:</b> {ipV4.isErrorOccurred ? 'Error occurred' : ipV4Data}</li>
                <li><b>IPv6:</b> {ipV6.isErrorOccurred ? 'Error occurred' : ipV6Data}</li>
            </ul>
        </div>
    );
};

export const getUserCountryByIp = async (clientIp) => {
    return apolloClient.query({
        query: GetCountryByIp,
        variables: {
            clientIp: clientIp,
        },
    });
};

export const getClientIpV4 = () => {
    return getClientIp(
        urls.services.getIpV4,
        /clientip>([\d+.]+)<\/clientip/
    );
};

export const getClientIpV6 = () => {
    return getClientIp(
        urls.services.getIpV6,
        /clientip>([0-9a-f:]+)<\/clientip/
    );
};

export const getClientIpV6orV4 = async () => {
    const ipV6 = await getClientIpV6();

    if (ipV6) {
        return ipV6;
    }

    const ipV4 = await getClientIpV4();

    if (ipV4) {
        return ipV4;
    }

    return '';
};

export const getDetectedClientIp = async (url) => {
    const ip = await getClientIp(url, /clientip>(.*)<\/clientip/);

    if (1 > ip.length) {
        throw new Error('IP address not detected from ' + url);
    }

    return ip;
};

const getClientIp = async (getIpUrl, ipRegex) => {
    try {
        const responseObject = await fetch(getIpUrl);

        if (!responseObject) {
            return null;
        } else {
            const responseText = await responseObject.text();

            return RegExp(ipRegex).exec(responseText) ? RegExp(ipRegex).exec(responseText)[1] : '';
        }
    } catch {
        return null;
    }
};
